var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxlTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxl-telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2482 4.18154L3.30192 11.8732C1.94067 12.4199 1.94855 13.1793 3.05217 13.5179L8.17317 15.1154L20.0217 7.63979C20.5819 7.29892 21.0938 7.48229 20.673 7.85579L11.0734 16.5194H11.0712L11.0734 16.5205L10.7202 21.799C11.2377 21.799 11.466 21.5617 11.7563 21.2815L14.2437 18.8628L19.4175 22.6844C20.3715 23.2098 21.0567 22.9398 21.294 21.8013L24.6904 5.79479C25.038 4.40092 24.1583 3.76979 23.2482 4.18154Z",
    fill: "url(#paint0_linear_862_6569)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_6569",
    x1: 13.5093,
    y1: 4.05737,
    x2: 13.5093,
    y2: 22.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxlTelegram);
export default __webpack_public_path__ + "static/media/bxl-telegram.879f004f1377248447e5ab1bb3ea2f3a.svg";
export { ForwardRef as ReactComponent };